/**
 * Chat functionality - Realtime broadcasting removed
 * This file provides JavaScript-side chat handling
 * All realtime functionality disabled - using Livewire polling instead
 */

document.addEventListener('DOMContentLoaded', function() {
    // Chat functionality without realtime features
    // All realtime functionality disabled - using Livewire polling instead
    
    // Helper function to update selected user (can be called from Livewire)
    window.updateChatSelectedUserId = function(userId) {
        // Functionality handled by Livewire
    };
});

// Livewire integration without realtime updates
document.addEventListener('livewire:load', function () {
    // Livewire handles all chat functionality
});